import React from 'react';
import { Grid } from '@material-ui/core';
import { get } from 'lodash';
import { List, ListItem } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import {
  StyledTitle,
  StyledListItem,
  SelectedStyledListItem,
  StyledAreaList,
} from 'containers/AttributionManager/styles';

export interface AreasListProps {
  intl: IntlShape;
  listings: any;
  setSelectedArea: Function;
  selectedArea: any;
  managerNotifications: any;
  managers: any;
  usersInboxes: any;
  countInboxes: any;
  inboxes: any;
}

export const AreasList: React.FC<AreasListProps> = (props): JSX.Element => {
  /* istanbul ignore next */
  const handleSelectArea = (el: any) => () => {
    props.setSelectedArea(el?.id as any);
  };
  return (
    <List style={StyledAreaList}>
      {get(props.listings, 'transactionArea', []).map((el: any) => (
        <ListItem
          style={
            props.selectedArea === el?.id
              ? SelectedStyledListItem
              : StyledListItem
          }
          data-testid={`Item+${el?.id}`}
          onClick={handleSelectArea(el)}
        >
          <Grid container direction="column" spacing={2} justify="center">
            <Grid item>
              <Grid container direction="row" alignItems="center" spacing={1}>
                <Grid item>
                  <span
                    style={
                      props.selectedArea === el?.id
                        ? { ...StyledTitle, color: '#FFF' }
                        : StyledTitle
                    }
                  >
                    {el?.title}
                  </span>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ListItem>
      ))}
    </List>
  );
};

export default injectIntl(AreasList);
